import styled from 'styled-components';

export const PageWrapper = styled.div`
	height: 100%;
	display: flex;
	flex-direction: column;
`;
export const FlexWrapper = styled.div`
	display: flex;
	flex-direction: row;
	flex-wrap: nowrap;
	justify-content: space-between;
	align-items: center;
	border-bottom: 1px solid #eeeeee;
`;
export const ContentDiv = styled.div`
	height: 100%;
	overflow: hidden;
	overflow-y: auto;
	padding-bottom: 10px;
`;

export const NavDiv = styled.div`
	height: 40px;
	padding: 0 0 0 20px;
	button {
		height: 40px;
		font-size: 12px;
	}
`;

export const SettingsWrapper = styled.div`
	padding-right: 20px;
`;
